export const ID_VALIDATION_ROUTES = {
  IS_PEP_OR_SO: '/is-pep-or-so',
  PEP_OR_SO_CONTACT: '/pep-or-so-contact',
  PEP_OR_SO_INFO: '/pep-or-so-info',
  REPRESENTATION: '/representation',
  JURIDICAL_VALIDATION: '/juridical-validation',
  ADDITIONAL_DOCUMENTATION: '/additional-documentation',
  PROOF_OF_LIFE: '/proof-of-life',
};
